<div class="wipe-modal" (keydown)="handleKeydown($event)" *ngIf="jsonRes">
        {{loadFocusTelements()}}
    <div class="modal-header">
        <h2 id='modalHeading' tabindex="0">{{jsonRes.heading_wipe}}</h2>
    </div>
    <div class="corner-button">
        <button class="close" aria-label="Close" (click)="cancelModal(false)" tabindex="0">x</button>
    </div>
    <div class="box-outer">
        <div class="modal-body">
            <div>{{jsonRes.ctn}}: {{ctn}} </div>
            <div>{{jsonRes.fan}}: {{fan}}</div>
            <div>{{jsonRes.ban}}: {{ban}}</div>
            <br>
            <div class = "description">{{jsonRes.wipe_description_1}}</div>
            <div class = "description">{{jsonRes.wipe_description_2}}</div>
            <div class = "description">{{jsonRes.wipe_description_3}}</div>
        </div>
        <!-- <div class="check">
            <div class="checkbox">
            <input id = "De-enroll device" (change)="is_acknowledged = !is_acknowledged" type="checkbox"/><i class="skin"></i><span >{{jsonRes.checkbox_name}}</span>
            </div>
        </div> -->
        <div class="check">
            <div class="checkbox">
                <label for="terms">
                    <input id="terms" tabindex="0" type="checkbox" [(ngModel)]="device.deenrolled"/><i class="skin"></i><span >{{jsonRes.checkbox_name}}</span>
                </label>
            </div> 
        </div>
    </div>
    <div class="text-right modal-footer row">
        <button class="btn btn-secondary col-md-5 col-sm-12 pull-right" tabindex="0" (click)="ok()" id="device-wipe-btn" checkImpersonator>{{jsonRes.buttons.ok}}</button>
        <a class="btn btn-link btn-block col-md-6 col-sm-12 btn-cancel pull-right text-right cancel-button-modal" tabindex="0"(click)="dimissModal(false)" (keydown)="dimissModal(false, $event)" >{{jsonRes.buttons.cancel}}</a>
       
    </div>
</div>